import React, { useEffect, useState } from "react";
import { HiOutlineMenu } from "react-icons/hi";
import { ReactComponent as UserIcon } from "./../assets/user_icon.svg";
import { Link } from "react-router";
import { PRIMARY_COLOR, TERTIARY_COLOR } from "../constants/theme";
import { getPatientbyID } from "../services/patient/patient.service";
import Config from "../services/config";
import { Avatar } from "@mui/material";
import ChatBot from "./ChatBot";
import { IoIosGlobe } from "react-icons/io";
import { getLatestScheduleByPatientId } from "../services/drSchedule/drSchedule.service";

const Header = ({
  toggleSidebar,
  setToggleSidebar,
  toggleDropdown,
  setToggleDropdown,
  openLogout,
  setOpenLogout,
}) => {
  const email = sessionStorage.getItem("email");
  const patientID = sessionStorage.getItem("patientId");

  const [profileData, setProfileData] = useState({
    first_name: "",
    last_name: "",
    age: 0,
    dob: "",
    age_group: "",
    gender: "",
    blood_group: "",
    mobile: "",
    phone: "",
    cnic: "",
    passport: "",
    whatsapp: "",
    zip_code: "",
    address: "",
    location: "",
    city: "",
    province: "",
    country: "",
    emergency_contact_name: "",
    emergency_contact_address: "",
    emergency_contact_mobile: "",
    emergency_contact_relation: "",
    shipping_address: "",
    shipping_zip_code: "",
    shipping_title: "",
    shipping_city: "",
    billing_address: "",
    billing_zip_code: "",
    billing_title: "",
    billing_city: "",
    full_name: "",
    email: "",
  });

  const getLatestAppointment = async () => {
    try {
      const res = await getLatestScheduleByPatientId(
        email,
        sessionStorage.getItem("patientId")
      );
      if (res.status === 200 && res.data.status === 200) {
        sessionStorage.setItem("appointmentId", res.data.data.schedule_id);
      }
    } catch (error) {
      console.log("Error fetching latest appointment => ", error);
    }
  };

  const getPatientData = async () => {
    try {
      const response = await getPatientbyID(email, patientID);

      if (response.status === 200) {
        setProfileData(response?.data?.data);
      } else {
        return;
      }
    } catch (error) {
      console.log("ERROR FETCHING PATIENT DATA => ", error);
      return;
    }
  };

  useEffect(() => {
    getLatestAppointment();
    getPatientData();
  }, []);

  return (
    <div
      className="col-12 position-relative"
      style={{
        padding: "10px 5px",
        zIndex: "999",
      }}
    >
      <div className="row w-100 mx-auto align-items-center justify-content-between">
        <div className="col-auto p-0">
          <div
            className="d-flex"
            style={{
              gap: "16px",
            }}
          >
            {!toggleSidebar ? (
              <button
                style={{
                  border: "none",
                  background: "none",
                  outline: "none",
                }}
                onClick={() => setToggleSidebar(!toggleSidebar)}
              >
                <HiOutlineMenu
                  style={{
                    color: "#fae5ff",
                    height: "29px",
                    width: "29px",
                  }}
                />
              </button>
            ) : null}

            {toggleSidebar ? null : (
              <Link
                style={{
                  color: "#fae5ff",
                  fontSize: "28px",
                  fontWeight: "600",
                  lineHeight: "1",
                  cursor: "pointer",
                  textDecoration: "none",
                }}
                to="/home"
              >
                SmileApp
              </Link>
            )}
          </div>
        </div>
        <div className="col-auto p-0 d-flex">
          <div className="position-relative">
            <button
              className="btn p-0"
              type="button"
              style={{
                width: "53px",
                border: "none",
                outline: "none",
              }}
            >
              <IoIosGlobe
                color={TERTIARY_COLOR}
                size={50}
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </button>
          </div>
          <div className="position-relative mt-1">
            {/* {window.location.pathname !== "/smile-bot" ? <ChatBot /> : null} */}
            <ChatBot />
          </div>
          <div className="position-relative mt-1">
            <button
              className="btn p-0"
              type="button"
              style={{
                width: "40px",
                border: "none",
                outline: "none",
              }}
              onClick={() => setToggleDropdown(!toggleDropdown)}
            >
              {profileData?.profile_picture ? (
                <Avatar
                  alt="Profile"
                  style={{
                    height: "105%",
                    width: "105%",
                  }}
                  src={
                    profileData.profile_picture
                      ? `${Config.filePath + profileData.profile_picture}`
                      : ""
                  }
                />
              ) : (
                <UserIcon
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                />
              )}
            </button>
            {toggleDropdown && (
              <ul
                className="dropdown-menu position-absolute end-0"
                style={{
                  fontSize: "12px",
                  top: "100%",
                  display: "block",
                }}
              >
                <li className="dropdown-item-parent">
                  <Link
                    className="dropdown-item"
                    style={{
                      color: PRIMARY_COLOR,
                    }}
                    to="/profile"
                  >
                    Profile
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    style={{
                      color: PRIMARY_COLOR,
                    }}
                    to="/teeth-profile"
                  >
                    Teeth Profile
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    style={{
                      color: PRIMARY_COLOR,
                    }}
                    to="/change-password"
                  >
                    Change Password
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    style={{
                      color: PRIMARY_COLOR,
                    }}
                    onClick={() => setOpenLogout(true)}
                    // to="/logout"
                    // role="button"
                    // data-bs-toggle="modal"
                    // data-bs-target="#logoutModal"
                  >
                    Logout
                  </button>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
